import { HasCartLineContext, withCartLine } from "@insite/client-framework/Components/CartLineContext";
import siteMessage from "@insite/client-framework/SiteMessage";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import { getCurrentCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import Undo from "@NA/Icons/Undo";
import { getCurrentPromotionsDataView } from "@insite/client-framework/Store/Data/Promotions/PromotionsSelectors";
import clearCurrentCart from "@insite/client-framework/Store/Pages/Cart/Handlers/ClearCurrentCart";
import removeCartLine from "@insite/client-framework/Store/Pages/Cart/Handlers/RemoveCartLine";
import updateCartLine from "@insite/client-framework/Store/Pages/Cart/Handlers/UpdateCartLine";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { CardContainerStyles } from "@insite/content-library/Components/CardContainer";
import { CardListStyles } from "@insite/content-library/Components/CardList";
import { CartPageContext } from "@insite/content-library/Pages/CartPage";
import { CartLineCardCondensedStyles } from "@insite/content-library/Widgets/Cart/CartLineCardCondensed";
import { CartLineCardExpandedStyles } from "@insite/content-library/Widgets/Cart/CartLineCardExpanded";
import { ButtonPresentationProps } from "@insite/mobius/Button";
import { IconPresentationProps } from "@insite/mobius/Icon";
import ShoppingCart from "@insite/mobius/Icons/ShoppingCart";
import { LinkPresentationProps } from "@insite/mobius/Link";
import { LoadingOverlayProps } from "@insite/mobius/LoadingOverlay";
import { LoadingSpinnerProps } from "@insite/mobius/LoadingSpinner";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import CustomApplicationState from "@NA/Store/Data/CustomApplicationState/CustomApplicationState";
import React, { useContext, useEffect, useState } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";
import addToCart from "@insite/client-framework/Store/Pages/Cart/Handlers/AddToCart";
import { makeHandlerChainAwaitable } from "@insite/client-framework/HandlerCreator";
import { CartLineModel, WishListLineModel } from "@insite/client-framework/Types/ApiModels";
import actionRemovedItem from "@NA/Handlers/ADISaveForLaterRemovedItem";
import { getWishListsDataView } from "@insite/client-framework/Store/Data/WishLists/WishListsSelectors";
import ADIMyListsDetailsProductListLine from "@NA/Components/WishList/ADIMyListsDetailsProductListLine";
import { ProductInfo } from "@insite/client-framework/Common/ProductInfo";
import deleteWishListLine from "@insite/client-framework/Store/Pages/MyListDetails/Handlers/DeleteWishListLine";
import addToWishList from "@insite/client-framework/Store/Data/WishLists/Handlers/AddToWishList";
import ToasterContext from "@insite/mobius/Toast/ToasterContext";
import setAddToListModalIsOpen from "@insite/client-framework/Store/Components/AddToListModal/Handlers/SetAddToListModalIsOpen";
import translate from "@insite/client-framework/Translate";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import ADIColors from "@NA/Utils/ADIColors";
import wishListLinesSaveItem from "@NA/Handlers/ADIWishListLinesSaveListHandler";
import loadWishLists from "@NA/Handlers/ADIQuoteRequestWishLists";
import setUpdateCartLoading from "@NA/Handlers/ADIUpdateCartLoadingHandler";
import ADIXtenExportToXtenButton from "@NA/Components/ADIXtenExportToXtenButton";
import { HideHeader } from "@insite/client-framework/Types/FieldDefinition";
import Hidden from "@insite/mobius/Hidden";

interface OwnProps extends WidgetProps {}

const mapStateToProps = (state: CustomApplicationState) => {
    let wishlistId = "";
    let s = null;
    const wishListsDataView = getWishListsDataView(state, undefined).value;
    const filteredWishList = wishListsDataView?.filter(item => item.properties.isSavedItemList === "1");
    if (filteredWishList && filteredWishList?.length > 0) {
        wishlistId = filteredWishList[0].id;
        s = filteredWishList[0];
    }

    return {
        cart: getCurrentCartState(state).value,
        promotionsDataView: getCurrentPromotionsDataView(state),
        settingsCollection: getSettingsCollection(state),
        isClearingCart: state.pages.cart.isClearingCart,
        isUpdatingCartLine: state.pages.cart.isUpdatingCartLine,
        isLoading: state.data.carts.isLoading,
        fetchRemovedItem: state.ADIGlobalData.removedItemStore.removedSave,
        wishlistId,
        fwishlist: s,
        wishListSettings: getSettingsCollection(state).wishListSettings,
    };
};

const mapDispatchToProps = {
    clearCurrentCart,
    updateCartLine,
    removeCartLine,
    actionRemovedItem,
    wishListLinesSaveItem,
    deleteWishListLine,
    addToCart: makeHandlerChainAwaitable(addToCart),
    loadWishLists,
    addToWishList,
    setAddToListModalIsOpen,
    setUpdateCartLoading,
};

type Props = OwnProps &
    HasCartLineContext &
    ReturnType<typeof mapStateToProps> &
    ResolveThunks<typeof mapDispatchToProps>;

export interface WistListLineStyles {
    wrapper?: InjectableCss;
    loadingOverlay?: LoadingOverlayProps;
    centeringWrapper?: InjectableCss;
    spinner?: LoadingSpinnerProps;
    noCartLinesText?: TypographyProps;
    noCartLinesIcon?: IconPresentationProps;
    cardList?: CardListStyles;
    cardContainer?: CardContainerStyles;
    cardExpanded?: CartLineCardExpandedStyles;
    cardCondensed?: CartLineCardCondensedStyles;
    footerWrapper?: InjectableCss;
    backToTopButton?: ButtonPresentationProps;
    undoLink?: LinkPresentationProps;
    headerWrapper?: InjectableCss;
    totalCount?: InjectableCss;
}

export const wistListLineStyles: WistListLineStyles = {
    centeringWrapper: {
        css: css`
            display: flex;
            flex-direction: column;
            height: 300px;
            justify-content: center;
            align-items: center;
        `,
    },
    noCartLinesText: {
        variant: "h3",
    },
    noCartLinesIcon: {
        src: ShoppingCart,
        size: 45,
        color: "text.link",
        css: css`
            margin-bottom: 20px;
        `,
    },

    footerWrapper: {
        css: css`
            display: flex;
            justify-content: center;
        `,
    },
    backToTopButton: {
        variant: "secondary",
        css: css`
            margin: 16px 0;
        `,
    },
    undoLink: {
        icon: {
            iconProps: {
                src: Undo,
                size: 12,
                css: css`
                    margin-left: 15px;
                `,
            },
        },
        typographyProps: { size: 14 },
    },
    headerWrapper: {
        css: css`
            border-bottom: 2px solid ${ADIColors.gray3};
            margin-top: 44px;
            padding-bottom: 5px;
            > h1 {
                font-size: 36px;
                color: #002856;
                margin: 0;
                line-height: 40px;
                font-weight: 600;
                display: inline;
                @media only screen and (max-width: 767px) {
                    line-height: 30px;
                    font-size: 28px;
                }
            }
            @media only screen and (max-width: 767px) {
                margin-top: 28px;
                display: block;
                padding-bottom: 12px;
            }
        `,
    },
    totalCount: {
        css: css`
            display: inline-block;
            margin-left: 1rem;
            font-size: 20px;
            line-height: 18px;
            font-weight: 400;
            @media only screen and (max-width: 767px) {
                display: block;
                margin: 0 !important;
                margin-top: 13px !important;
                border-bottom: none;
                font-weight: normal;
            }
        `,
    },
};

const styles = wistListLineStyles;

const ADIWistListLine = ({
    wishlistId,
    wishListLinesSaveItem,
    fwishlist,
    deleteWishListLine,
    addToCart,
    loadWishLists,
    wishListSettings,
    cartLine,
    addToWishList,
    setAddToListModalIsOpen,
    fetchRemovedItem,
    setUpdateCartLoading,
    cart,
}: Props) => {
    const [savedItemList, setSaveItemList] = useState<WishListLineModel[]>();
    const toasterContext = useContext(ToasterContext);

    const [isApiLoading, setIsApiLoading] = useState(true);
    const [saveProductId, setSaveProductId] = useState("");
    const [wishlist, setWishlist] = useState(fwishlist);

    useEffect(() => {
        if (fwishlist) {
            setWishlist(fwishlist);
        }
    }, [fwishlist]);

    const deleteSubmitHandler = (wishlistLineData: WishListLineModel) => {
        if (!wishlistLineData) {
            return;
        }

        if (wishlistId != "") {
            deleteWishListLine({
                wishListId: wishlistId,
                wishListLineId: wishlistLineData.id,
                onSuccess: () => {
                    loadWishLists({
                        onComplete(result) {
                            setUpdateCartLoading({ loading: false });
                            // getWishListLine();
                        },
                    });
                },
            });
        } else {
            loadWishLists({
                onComplete(result) {
                    let wishListIdLocal = "";
                    const filteredWishList = result.apiResult?.wishListCollection?.filter(
                        item => item.properties.isSavedItemList === "1",
                    );
                    if (filteredWishList && filteredWishList?.length > 0) {
                        wishListIdLocal = filteredWishList[0].id;
                        deleteWishListLine({
                            wishListId: wishListIdLocal,
                            wishListLineId: wishlistLineData.id,
                            onSuccess: () => {
                                loadWishLists({
                                    onComplete(result) {
                                        getWishListLine();
                                        setUpdateCartLoading({ loading: false });
                                    },
                                });
                            },
                        });
                    }
                },
            });
        }
    };

    const addToListClickHandler = () => {
        if (!wishListSettings) {
            return;
        }

        const productInfo = {
            productId: cartLine.productId!,
            qtyOrdered: cartLine.qtyOrdered!,
            unitOfMeasure: cartLine.unitOfMeasure,
        };
        if (!wishListSettings.allowMultipleWishLists) {
            addToWishList({
                productInfos: [productInfo],
                onSuccess: () => {
                    toasterContext.addToast({ body: siteMessage("Lists_ProductAdded"), messageType: "success" });
                },
                onComplete(resultProps) {
                    if (resultProps.result?.wishList) {
                        // "this" is targeting the object being created, not the parent SFC
                        // eslint-disable-next-line react/no-this-in-sfc
                        this.onSuccess?.(resultProps.result.wishList);
                    } else if (resultProps.result?.errorMessage) {
                        toasterContext.addToast({ body: resultProps.result.errorMessage, messageType: "danger" });
                    }
                },
            });
            return;
        }

        setAddToListModalIsOpen({ modalIsOpen: true, productInfos: [productInfo] });
    };

    const moveToCart = async (wishlistLineData: WishListLineModel) => {
        sessionStorage.setItem("item_list_name", "Saved Items");
        deleteSubmitHandler(wishlistLineData);
        await addToCart({
            productId: wishlistLineData.productId,
            qtyOrdered: wishlistLineData.qtyOrdered,
            unitOfMeasure: wishlistLineData.unitOfMeasure,
        });
        setUpdateCartLoading({ loading: false });
    };

    const onCompleteGetWishList = (result: any) => {
        sessionStorage.setItem("item_list_name", "Saved Items");
        if (result && result?.wishListLines) {
            const newWishListLine = result?.wishListLines.map((item: any) => {
                item.pricing = result.productInfosByWishListLineId[item.id].pricing;
                return item;
            });
            setSaveItemList(newWishListLine);
        }
    };

    const getWishListLine = () => {
        if (wishlistId) {
            wishListLinesSaveItem({
                wishListId: wishlistId,
                newParameter: {},
                productInfosByWishListLineId: {},
                onSuccess(result: any) {
                    onCompleteGetWishList(result);
                },
                onComplete(res: any) {
                    if (res && res?.wishListLines?.length === 0) {
                        setSaveItemList([]);
                        setIsApiLoading(true);
                    }
                },
            });
        }
    };

    useEffect(() => {
        if (
            wishlistId &&
            fetchRemovedItem &&
            fetchRemovedItem.productId &&
            saveProductId !== fetchRemovedItem.productId
        ) {
            setSaveProductId(fetchRemovedItem.productId);
        }

        getWishListLine();

        if (isApiLoading) {
            setIsApiLoading(false);
        }
    }, [fetchRemovedItem, wishlistId]);

    if (!wishlist) {
        return null;
    }
    if (!savedItemList) {
        return null;
    }

    return (
        <div data-test-selector="savedItemsWrapper">
            {savedItemList.length !== 0 && (
                <StyledWrapper {...styles.headerWrapper}>
                    <Typography variant="h1">{translate(" Saved Items")}</Typography>
                    {savedItemList.length === 1 ? (
                        <Typography variant="p" {...styles.totalCount}>{`${savedItemList.length} Item`}</Typography>
                    ) : (
                        <Typography variant="p" {...styles.totalCount}>{`${savedItemList.length} Items`}</Typography>
                    )}
                </StyledWrapper>
            )}
            {savedItemList.map(item => {
                return (
                    <ADIMyListsDetailsProductListLine
                        key={item.id}
                        wishList={wishlist}
                        wishListLine={item}
                        productInfo={item as unknown as ProductInfo}
                        onDeleteClick={deleteSubmitHandler}
                        onMoveToCartClick={moveToCart}
                        onEditNotesClick={() => {}}
                    />
                );
            })}
        </div>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(withCartLine(ADIWistListLine)),
    definition: {
        group: "Cart",
        displayName: "ADI Save Deleted cart",
        allowedContexts: [CartPageContext],
    },
};

export default widgetModule;
